"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "FRIDAY": "Петък",
    "MONDAY": "Понеделник",
    "SATURDAY": "Cъбота",
    "SUNDAY": "Неделя",
    "THURSDAY": "четвъртък",
    "TUESDAY": "Вторник",
    "WEDNESDAY": "Сряда",
    "and": "и",
    "day": "ден",
    "day_one": "ден",
    "day_other": "дни",
    "day_plural": "дни",
    "freeOfCharge": "Безплатно",
    "hour_one": "час",
    "hour_one_plural": "часа",
    "hour_other": "часа",
    "minute": "минута",
    "minute_one": "минута",
    "minute_other": "минути",
    "ocpiRestrictionsAfterDuration": "След {{minDuration}}",
    "ocpiRestrictionsBetweenDuration": "Между {{minDuration}} и {{maxDuration}}",
    "ocpiRestrictionsFirstDuration": "Първи {{maxDuration}}",
    "ocpiRestrictionsKwhAbove": "Когато консумацията на енергия над {{minKwh}}",
    "ocpiRestrictionsKwhBetween": "Когато консумацията на енергия между {{minKwh}} и {{maxKwh}}",
    "ocpiRestrictionsKwhLessThan": "Когато консумацията на енергия е по-малка от {{maxKwh}}",
    "session": "сесия",
    "theDay": "ден",
    "theDay_one": "ден",
    "theDay_other": "дни",
    "theHour": "час",
    "theHour_one": "час",
    "theHour_other": "часа",
    "theMinute": "минута",
    "theMinute_one": "минута",
    "theMinute_other": "минути"
};
